var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("page " + (_vm.blok.content.layout || ''))},_vm._l((_vm.blok.content.columns),function(bk){return _c('column',{key:bk._uid,attrs:{"blok":bk,"columns":_vm.blok.content.columns.length}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }